















































































import Vue from 'vue'
import Component from 'vue-class-component'
import Login from "@/components/Login.vue";
import {Machine} from "@/modules/unigest";
import MachineSelect from "@/components/MachineSelect.vue";
import {State} from "vuex-class";
import {insert} from "@/modules/config";

/**
 * Asistente para la configuración del dispositivo de firmas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {MachineSelect, Login}
})
export default class SetupGuide extends Vue {

    /**
     * Controla la visbilidad de la guia para la configuración de la app
     */
    public setupGuide = false

    public step = 1

    @State
    public machine: Machine

    public activatingScreenLock = false

    /**
     * Activa la maquina seleccionada
     *
     * @param machine
     */
    public async activateMachine (machine: Machine) {
        await this.$store.dispatch('activateMachine', machine)
        this.step = 3
    }

    /**
     * Configura el PDF para la protección de datos
     * @param file
     */
    public async configurePDF (file: File) {
        const toDataURL = () => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result)
                reader.onerror = reason => reject(reason)

                reader.readAsDataURL(file)
            })
        }

        const dataURL = await toDataURL()

        insert('pdf', dataURL)
    }

    created () {
        // Si la aplicación ya se encuentra configurada se redirige al usuario a la
        // pantalla de inicio
        if (this.$store.getters.isConfigured) {
            this.$router.push({name: 'home'})
        }
    }

    public async finish () {
        await this.$store.dispatch('initSignatureCommunication')
        await this.$router.push({name: 'home'})
    }
}
